module.exports = __webpack_public_path__ + "img/266.0cee6289.png";